import { baseApi } from '@/services/api';
import { VercelProject, VercelDeployment } from './vercelTypes';

export const vercelAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    connectVercel: builder.mutation<{ auth_url: string }, void>({
      query: () => ({
        url: '/vercel/connect',
        method: 'POST',
      }),
    }),
    
    disconnectVercel: builder.mutation<void, void>({
      query: () => ({
        url: '/vercel/disconnect',
        method: 'POST',
      }),
      invalidatesTags: ['Integrations'],
    }),
    
    getVercelStatus: builder.query<{ connected: boolean }, void>({
      query: () => ({
        url: '/vercel/status',
        method: 'GET',
      }),
      providesTags: ['Integrations'],
    }),
    
    getVercelProjects: builder.query<VercelProject[], void>({
      query: () => ({
        url: '/vercel/projects',
        method: 'GET',
      }),
      providesTags: ['Integrations'],
    }),
    
    deployToVercel: builder.mutation<VercelDeployment, {
      project_id: string;
      project_name?: string;
      environment_vars?: Record<string, string>;
      custom_domain?: string;
      framework?: string;
      build_command?: string;
      install_command?: string;
      output_directory?: string;
    }>({
      query: (data) => ({
        url: '/vercel/deploy',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Deployments'],
    }),
    
    getVercelDeployments: builder.query<VercelDeployment[], { project_id?: string }>({
      query: (params) => ({
        url: '/vercel/deployments',
        method: 'GET',
        params,
      }),
      providesTags: ['Deployments'],
    }),
  }),
});

export const {
  useConnectVercelMutation,
  useDisconnectVercelMutation,
  useGetVercelStatusQuery,
  useGetVercelProjectsQuery,
  useDeployToVercelMutation,
  useGetVercelDeploymentsQuery,
} = vercelAPI;
